import { Card, Form, Select, Button, DatePicker, message, Space } from 'antd';
import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import MemberSelector from '../components/MemberSelector';

const { RangePicker } = DatePicker;

const AiLearning = ({ user }) => {
  const { apiClient } = useAuth();
  const [form] = Form.useForm();
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showMemberFilter, setShowMemberFilter] = useState(false);

  // 设置 dayjs 为中文
  dayjs.locale('zh-cn');

  const handleMemberSelect = (member) => {
    const isSelected = selectedMembers.some(m => m.id === member.id);
    if (isSelected) {
      setSelectedMembers(selectedMembers.filter(m => m.id !== member.id));
    } else {
      setSelectedMembers([...selectedMembers, member]);
    }
  };

  const handleExport = async () => {
    try {
      const values = await form.validateFields();
      let trainDateStart = null;
      let trainDateEnd = null;
      
      if (values.trainDateRange) {
        trainDateStart = values.trainDateRange[0] ? values.trainDateRange[0].format('YYYY-MM-DD') : null;
        trainDateEnd = values.trainDateRange[1] ? values.trainDateRange[1].format('YYYY-MM-DD') : null;
      }

      const data = {
        babyIdList: selectedMembers.map(m => m.id),
        trainDateStart: trainDateStart,
        trainDateEnd: trainDateEnd,
        pageSize: 999999,   //固定值
        pageNo: 1  //固定值
      };

      setLoading(true);
      const response = await apiClient.post('/sports-server-prod/taller.api.v1/prescription/exportAiTrainingData', data, {
        responseType: 'blob',
      });

      if (response.data) {
        // 获取后端返回的文件名
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'ai_training_data.xlsx'; // 默认文件名
        
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1].replace(/['"]/g, '');
          }
        }

        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        message.success('导出成功');
      } else {
        message.warning('未匹配到数据');
      }
    } catch (error) {
      console.error('导出失败:', error);
      message.error('导出失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="AI学习数据导出">
        <Form form={form} layout="vertical">
          <Space style={{ width: '100%', justifyContent: 'space-between' }}>
            <Form.Item
              name="trainDateRange"
              label="训练日期范围"
              style={{ marginBottom: 0 }}
            >
              <RangePicker format="YYYY-MM-DD" />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button type="primary" onClick={handleExport} loading={loading}>
                导出
              </Button>
            </Form.Item>
          </Space>

          <Form.Item>
            <Button 
              type="link" 
              onClick={() => setShowMemberFilter(!showMemberFilter)}
            >
              {showMemberFilter ? '隐藏会员筛选' : '过滤会员'}
            </Button>
          </Form.Item>

          {showMemberFilter && (
            <Form.Item label="会员选择">
              <MemberSelector
                onSelect={handleMemberSelect}
                selectedMemberIds={selectedMembers.map(m => m.id)}
              />
              <div style={{ marginTop: 8 }}>
                已选择会员: {selectedMembers.map(m => m.babyName).join(', ')}
              </div>
            </Form.Item>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default AiLearning;